export const INSURANCE_REMINDERS_CHANGED_EVENT = 'insurance-reminders-changed'

export function notifyInsuranceRemindersChanged(): void {
  window.dispatchEvent(new Event(INSURANCE_REMINDERS_CHANGED_EVENT))
}
